/**
 * Generate a time-based greeting message
 * @param name - User's name to include in the greeting
 * @returns Personalized greeting based on current time
 */
export const getTimeBasedGreeting = (name: string): string => {
  const hour = new Date().getHours();
  
  if (hour < 12) {
    return `Good morning, ${name}!`;
  } else if (hour < 18) {
    return `Good afternoon, ${name}!`;
  } else {
    return `Good evening, ${name}!`;
  }
};

/**
 * Get a motivational tagline for the dashboard
 * @returns Random motivational message about market intelligence
 */
export const getMotivationalTagline = (): string => {
  const taglines = [
    'Your gateway to global hospitality intelligence',
    'Empowering decisions with market insights',
    'Navigate the future of hospitality',
    'Where data meets opportunity',
    'Transform insights into action',
  ];
  
  return taglines[Math.floor(Math.random() * taglines.length)];
};